import "./infoHeader.scss";

import React from "react";
import { useSelector } from "react-redux";

const moment = require("jalali-moment");

const InfoHeader = ({ infos }) => {
  // store
  const darkThemeFromStore = useSelector((state) => state.Reducer.darkTheme);

  // Get today's date in Persian
  const today = moment().locale("fa");

  // Get the day, month, and year separately
  const day = today.format("D");
  const month = today.format("MMMM");
  const year = today.format("YYYY");

  // Get the day of the week
  const dayOfWeek = today.format("dddd");

  return (
    <div>
      <div className="infos date">
        <div>
          امروز : {dayOfWeek} {day} {month} {year}
        </div>
        <div className="info-data hid-800">{infos}</div>
        <div>
            کد نیما: <span className="nima-code">13424</span>
        </div>
      </div>
      <div className="date w-800">
        <div className="info-data">{infos}</div>
      </div>
    </div>
  );
};

export default InfoHeader;
